import {
  Filter,
  FilterTag,
  FilterValueStatus,
  FilterTagStatus,
  FilterSearchCriteria,
  workScopeFilterNames,
} from './filter.model';

export function processFilter(filter: Filter): FilterTag[] {
  return filter.values
    .filter(v => v.status && v.status !== FilterValueStatus.off)
    .map(v => {
      const status = v.status === FilterValueStatus.includes ? FilterTagStatus.includes : FilterTagStatus.excludes;

      return {
        value: v,
        filter,
        status,
      };
    }) as FilterTag[];
}

export function processRangeFilter(filter: Filter, saved: boolean = false): FilterTag[] {
  const name = filter.values[0].value + ' - ' + filter.values[1].value;
  const value = { name, status: FilterValueStatus.rangeIncludes };
  return [{ value, filter, saved }];
}

export function processSingleValueFilter(filter: Filter, saved: boolean = false): FilterTag[] {
  const status = 'publishingIncludes';
  return filter.values
    .filter(v => v.status && v.status !== FilterValueStatus.off)
    .map(v => ({
      value: {
        removeName: v.name,
        name: v.name === '100' ? `${v.name}%` : `> ${v.name}%`,
        status,
      },
      filter,
      saved,
      status,
    })) as FilterTag[];
}

export function isRangeFilter(filter: Filter): boolean {
  return filter.min && filter.opened;
}

export function isSingleValueFilter(filter: Filter): boolean {
  return filter.name === 'country_control_percent';
}

export function addRangeSliderSearchCriteria(filter: Filter, acc: FilterSearchCriteria): FilterSearchCriteria {
  const update = {
    rangeSearchFilter: {
      name: filter.name,
      min: filter.values[0].value,
      max: filter.values[1].value,
    },
  };
  return {
    rangeSearchFilter: [].concat(acc.rangeSearchFilter, update.rangeSearchFilter),
    includeFilters: [].concat(acc.includeFilters, []),
    excludeFilters: [].concat(acc.excludeFilters, []),
  };
}

export function addSingleValueSearchCriteria(filter: Filter, acc: FilterSearchCriteria): FilterSearchCriteria {
  const update = {
    rangeSearchFilter: filter.values
      .filter(v => v.status === 'includes')
      .map(v => {
        return {
          name: filter.name,
          min: parseInt(v.name, 10),
          max: 100,
        };
      }),
  };
  return {
    rangeSearchFilter: [].concat(acc.rangeSearchFilter, update.rangeSearchFilter),
    includeFilters: [].concat(acc.includeFilters, []),
    excludeFilters: [].concat(acc.excludeFilters, []),
  };
}

export function addSearchCriteria(filter: Filter, acc: FilterSearchCriteria): FilterSearchCriteria {
  const update = {
    includeFilters: {
      name: filter.name,
      values: filter.values.filter(v => v.status === 'includes').map(v => v.name),
    },
    excludeFilters: {
      name: filter.name,
      values: filter.values.filter(v => v.status === 'excludes').map(v => v.name),
    },
  };

  return {
    rangeSearchFilter: [].concat(acc.rangeSearchFilter, []),
    includeFilters: [].concat(acc.includeFilters, update.includeFilters).filter(f => f.values.length),
    excludeFilters: [].concat(acc.excludeFilters, update.excludeFilters).filter(f => f.values.length),
  };
}

export function hasSingleValue(filter: Filter): boolean {
  return filter.values.filter(v => v.status === 'includes').length !== 0;
}

export function isSingleValueTag(tag: FilterTag): boolean {
  return tag.value && Boolean(tag.value.removeName);
}

export function isAvailableOnWorkSearch(filter: Filter): boolean {
  return workScopeFilterNames.includes(filter.name);
}

export function modifyChartYear(year: number): number {
  let modifiedYear = 0;
  if (year === 2020) {
    modifiedYear = new Date().getFullYear();
  } else {
    modifiedYear = parseInt(year.toString().slice(0, -1) + '9', 10);
  }
  return modifiedYear;
}
